import React, { ReactNode } from 'react';
import { BloodVisionIndiaProvider } from 'components/blood-vision/BloodVisionIndiaContext';

interface IndiaLayoutProps {
  children: ReactNode;
}

/** Hoists the provider above /blood-vision/buy/in and its checkout child so cart
 *  and checkout state survive navigation between them. */
const IndiaLayout: React.FC<IndiaLayoutProps> = ({ children }) => {
  return <BloodVisionIndiaProvider>{children}</BloodVisionIndiaProvider>;
};

export default IndiaLayout;
